<template>
  <AppForm label="配信面">
    <v-layout row wrap>
      <v-flex xs4 style="max-width:160px;">
        <v-checkbox
          :disabled="advanced.requiredMobileApp"
          v-model="mobileApp"
          :false-value="false"
          label="アプリ"
        />
      </v-flex>
      <v-flex xs4 style="max-width:160px;">
        <v-checkbox v-model="web" :false-value="false" label="Webブラウザ" />
      </v-flex>
    </v-layout>
    <v-layout column wrap>
      <template v-if="errorMessages">
        <div
          v-for="message in errorMessages"
          class="red--text caption"
          style="margin-bottom: 8px"
        >
          {{ message }}
        </div>
      </template>
    </v-layout>
  </AppForm>
</template>

<script>
import uniq from 'lodash/uniq'
import {
  DeliveryDevices,
  DeliveryInventories,
} from '@/models/CampaignOperation/Constants'
import { MenuTypes } from '@/models/Menu/Constants'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    advanced: {
      type: Object,
      default: () => {},
    },
    menuType: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    MenuTypes() {
      return MenuTypes
    },
    web: {
      get() {
        return this.value.some(
          inventory =>
            inventory === DeliveryInventories.WEB ||
            inventory === DeliveryInventories.MOBILE_WEB,
        )
      },
      set(value) {
        if (value) {
          this.checkWeb()
          return
        }
        this.remove([DeliveryInventories.WEB, DeliveryInventories.MOBILE_WEB])
      },
    },
    mobileApp: {
      get() {
        return this.value.includes(DeliveryInventories.MOBILE_APP)
      },
      set(value) {
        if (value) {
          this.$emit(
            'input',
            this.value.concat([DeliveryInventories.MOBILE_APP]),
          )
          return
        }
        this.remove([DeliveryInventories.MOBILE_APP])
      },
    },
    errorMessages() {
      const result = []
      if (
        (this.advanced.deliveryDevices.includes(DeliveryDevices.PC) ||
          this.web) &&
        this.menuType !== MenuTypes.Retargeting &&
        this.menuType !== MenuTypes.Office
      ) {
        result.push(
          'PCやWebブラウザに配信する場合、不正確な位置情報に基づいて配信される可能性があります。',
        )
      }
      if (this.advanced.isIncorrectInventoryCombinationWithPC) {
        result.push(
          '配信デバイスにPCを設定する場合配信面にWebブラウザを指定する必要があります。',
        )
      }
      if (this.advanced.isIncorrectInventoryCombinationWithMobile) {
        result.push(
          '配信デバイスにスマートフォンもしくはタブレットを指定する場合、配信面にWebブラウザ' +
            'もしくはアプリのいずれか一つ以上を指定する必要があります。',
        )
      }
      return result.length > 0 ? result : false
    },
  },
  watch: {
    'advanced.deliveryDevices': {
      handler(deliveryDevices) {
        if (deliveryDevices.includes(DeliveryDevices.PC)) {
          this.checkWeb()
        }
      },
      deep: true,
    },
  },
  methods: {
    remove(inventories) {
      const result = this.value.filter(
        inventory => !inventories.includes(inventory),
      )
      this.$emit('input', result)
    },
    checkWeb() {
      const newValues = uniq(
        this.value.concat([
          DeliveryInventories.WEB,
          DeliveryInventories.MOBILE_WEB,
        ]),
      )
      this.$emit('input', newValues)
    },
  },
}
</script>

<style></style>
